import { Box, Typography } from "@mui/material";
import { ArticlesList } from "components/blog/articles-list";
import { useHistory } from "react-router-dom";

export const WhatsNewPage = () => {
  const history = useHistory();

  const handleArticleClick = (identifier: string) => {
    history.push(`/whats-new/${identifier}`);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        maxWidth: "1500px",
        margin: "0 auto",
        padding: "24px",
      }}
    >
      <Typography variant="h4" fontWeight={700}>
        Whats New
      </Typography>

      <ArticlesList onArticleClick={handleArticleClick} />
    </Box>
  );
};
